import { createContext } from 'react';

export default createContext({
	subscribeToProjects: () => { },
	subscribeToProject: (projectId: string) => { },
	unsubscribeFromProject: (projectId: string) => { },
	unsubscribeFromProjects: () => { },
	executeAction: (projectId: string, actionName: string, details: object) => { },
});
